// Module-level fetch + cache of the coin icon map so HeaderSearch and the
// widget coin picker share one network round-trip. Returns a getter that
// resolves coin symbol → CDN icon URL with a sensible fallback.

import { useEffect, useState } from 'react';
import { API_BASE_URL } from '../../utils/apiConfig';
import { DEFAULT_COIN_ICON } from '../../utils/helpers';

let cache = null;
let pending = null;

async function load() {
  if (cache) return cache;
  if (pending) return pending;
  pending = (async () => {
    try {
      const apiResponse = await fetch(`${API_BASE_URL}/api/icons/all`);
      if (apiResponse.ok) {
        cache = await apiResponse.json();
        return cache;
      }
    } catch {
      // fall through to static JSON fallback
    }
    try {
      const res = await fetch(`${API_BASE_URL}/mapped_symbols.json`);
      if (res.ok) {
        cache = await res.json();
        return cache;
      }
    } catch {
      // ignore — caller will get the default icon
    }
    cache = {};
    return cache;
  })().finally(() => { pending = null; });
  return pending;
}

export function useCoinIcons() {
  const [map, setMap] = useState(() => cache || {});
  useEffect(() => {
    let alive = true;
    if (!cache) {
      load().then((m) => { if (alive) setMap(m); });
    } else {
      setMap(cache);
    }
    return () => { alive = false; };
  }, []);

  const getCoinIcon = (coin) => {
    if (!coin) return DEFAULT_COIN_ICON;
    return map[`${coin.toUpperCase()}USDT`] || DEFAULT_COIN_ICON;
  };

  return { iconMap: map, getCoinIcon };
}
